var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7753906,14.6855469C29.3759766,8.0947266,23.3310547,4,16,4S2.6240234,8.0947266,0.2246094,14.6855469 C0.0751953,15.0947266,0,15.5371094,0,16s0.0751953,0.9052734,0.2246094,1.3144531C2.6240234,23.9052734,8.6689453,28,16,28 s13.3759766-4.0947266,15.7753906-10.6855469C31.9248047,16.9052734,32,16.4628906,32,16 S31.9248047,15.0947266,31.7753906,14.6855469z M29.8964844,16.6308594C27.7919922,22.4101562,22.4677734,26,16,26 S4.2080078,22.4101562,2.1035156,16.6308594C2.0351562,16.4414062,2,16.2294922,2,16s0.0351562-0.4414062,0.1035156-0.6308594 C4.2080078,9.5898438,9.5322266,6,16,6s11.7919922,3.5898438,13.8964844,9.3691406C29.9648438,15.5585938,30,15.7705078,30,16 S29.9648438,16.4414062,29.8964844,16.6308594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3085938,0-6,2.6914062-6,6s2.6914062,6,6,6s6-2.6914062,6-6S19.3085938,10,16,10z M16,20 c-2.2060547,0-4-1.7939453-4-4s1.7939453-4,4-4s4,1.7939453,4,4S18.2060547,20,16,20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSmall);
export default __webpack_public_path__ + "static/media/eye--small.d48f45176ba2e21708ba99588ce3d14e.svg";
export { ForwardRef as ReactComponent };